import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import Table, { TableBody, TableCell, TableHead, TableRow } from 'material-ui/Table';
import { withStyles } from 'material-ui/styles';
import { FormControl } from 'material-ui/Form';
import * as actions from '../../costEstimate.actions';
import { getInspectionById } from '../../../inspection/inspection.selectors';
import { getCostEstimateForType } from '../../costEstimate.selectors';
import { getCurrentUser, getCurrentUserRole } from '../../../user/user.selectors';
import { UserRoles } from '../../../user/user.constants';
const styles = theme => ({
  root: {
    borderCollapse: 'separate',
    tableLayout: 'fixed',
    padding: '16px',
  },
  head: {
    color: theme.palette.text.hint,
    background: 'rgba(175, 175, 175, 0.1)',
    height: 60,
  },
  headRow: {
    height: 'inherit',
  },
  headCell: {
    height: 'inherit',
    verticalAlign: 'middle',
  },
  cellLabel: {
    width: '100%',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  hidden: {
    padding: 16,
    color: 'rgba(0, 0, 0, 0.38)',
  },
});
const rows = [
  { label: 'Pyyntihinta (alv 0%)', name: 'offeredPrice', adornment: '€' },
  { label: 'Tavoitehinta (alv 0%)', name: 'goalPrice', adornment: '€' },
  { label: 'Kate %', name: 'marginPercent', adornment: '%' },
  { label: 'Kate € (alv 0%)', name: 'marginCurrency', adornment: '€' },
  {
    label: 'Koneen arvoa nostava työlaite (alv 0%)',
    name: 'missingEquipment',
    adornment: '€',
  },
  {
    label: 'Korjausarvio (työ ja osat) (alv 0%)',
    name: 'repairEstimate',
    adornment: '€',
  },
  { label: 'Kuljetus ja varastointi (alv 0%)', name: 'logistics', adornment: '€' },
  {
    label: 'Vaihtoesineen nettohyvitys (alv 0%)',
    name: 'netCredit',
    adornment: '€',
  },
  {
    label: 'Kommentit', name: 'comment', adornment: ''
  }
];
class CostEstimateForm extends Component {
  static propTypes = {
    backPath: PropTypes.string.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      sellerEstimate: {
        _id: undefined,
        inspection: props.id,
        type: 'seller', //either seller or department
        offeredPrice: null,
        goalPrice: null,
        marginPercent: null,
        marginCurrency: null,
        missingEquipment: null,
        repairEstimate: null,
        logistics: null,
        netCredit: null,
        remarks: '',
        comment: ''
      },
      departmentEstimate: {
        _id: undefined,
        inspection: props.id,
        type: 'department', //either seller or department
        offeredPrice: null,
        goalPrice: null,
        marginPercent: null,
        marginCurrency: null,
        missingEquipment: null,
        repairEstimate: null,
        logistics: null,
        netCredit: null,
        remarks: '',
        comment: ''
      },
      errors: [],
    };
  }
  componentDidMount = () => {
    const { readCostEstimates, id } = this.props;
    readCostEstimates(id);
  };

  componentWillReceiveProps(nextProps) {
    // You don't have to do this check first, but it can help prevent an unneeded render
    if (nextProps.sellerCostEstimate._id && !this.state.sellerEstimate._id) {
      this.setState({
        sellerEstimate: nextProps.sellerCostEstimate,
      });
    }
    if (
      nextProps.departmentCostEstimate &&
      nextProps.departmentCostEstimate._id &&
      !this.state.departmentEstimate._id
    ) {
      this.setState({ departmentEstimate: nextProps.departmentCostEstimate });
    }
  }

  onChange = (event, estimateType) => {
    const updatedEstimate = {
      ...this.state[estimateType],
      [event.target.name]: event.target.value,
    };

    this.setState({
      [estimateType]: updatedEstimate,
    });
    //const dataToSave = omit(dataToSaveWithoutEmptyObjects, event.errorKeys);
    this.throttledUpdate(updatedEstimate);
  };

  getValue(value, adornment) {
    if (value || value === 0 || value === '0') {
      return value.toString() + ' ' + adornment;
    }
    return '';
  }

  renderSellerEstimate() {
    const { classes } = this.props;
    const { sellerEstimate } = this.state;
    if (!sellerEstimate) return null;
    return (
      <TableBody>
        {rows.map((row, i) => {
          return (
            <TableRow key={i}>
              <TableCell padding="none" className={classes.labelCell}>
                <FormControl className={classes.cellLabel}>{row.label}</FormControl>
              </TableCell>
              <TableCell>
                <FormControl className={classes.cellLabel}>
                  {this.getValue(sellerEstimate[row.name], row.adornment)}
                </FormControl>
              </TableCell>
            </TableRow>
          );
        })}
      </TableBody>
    );
  }
  renderDepartmentEstimate(hasSellerEstimate) {
    const { classes } = this.props;
    const { sellerEstimate, departmentEstimate } = this.state;
    return (
      <TableBody>
        {rows.map((row, index) => {
          return (
            <TableRow key={index}>
              <TableCell className={classes.labelCell}>
                <FormControl className={classes.cellLabel}>{row.label}</FormControl>
              </TableCell>
              {hasSellerEstimate ? (
                <TableCell className={classes.labelCell}>
                  <FormControl className={classes.cellLabel}>
                    {this.getValue(sellerEstimate[row.name], row.adornment)}
                  </FormControl>
                </TableCell>
              ) : null}
              <TableCell>
                <FormControl className={classes.cellLabel}>
                  {this.getValue(departmentEstimate[row.name], row.adornment)}
                </FormControl>
              </TableCell>
            </TableRow>
          );
        })}
      </TableBody>
    );
  }
  render() {
    const { classes, isDepartment } = this.props;
    const { sellerEstimate } = this.state;
    let columns = [''];
    const hasSellerEstimate = sellerEstimate && sellerEstimate._id;
    if (hasSellerEstimate) columns.push('Myyjän arvio');
    if (isDepartment) columns.push('Osaston arvio');
    return (
      <div>
        { hasSellerEstimate ? ( //(isDepartment || hasSellerEstimate) && !isGuest ? (
          <Table className={classes.root}>
            {columns.length > 0 && (
              <TableHead className={classes.head}>
                <TableRow className={classes.headRow}>
                  {columns.map((prop, index) => {
                    return (
                      <TableCell key={index} className={classes.headCell}>
                        <div className={classes.cellLabel}>{prop}</div>
                      </TableCell>
                    );
                  })}
                </TableRow>
              </TableHead>
            )}
            {!isDepartment ? this.renderSellerEstimate() : this.renderDepartmentEstimate(hasSellerEstimate)}
          </Table>
        ) : (
          <h2 disabled className={classes.hidden}>
            (Hinta-arvio piilotettu)
          </h2>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state, { match, backPath }) => {
  const { params: { id } } = match;
  backPath = '/';
  const role = getCurrentUserRole(state);
  const inspection = getInspectionById(state, id);
  const user = getCurrentUser(state);
  const isDepartmentOrOwnerOfInspection =
    (role && (role === UserRoles.DEPARTMENT || role === UserRoles.SUPERUSER)) ||
    (inspection && inspection.createdBy && user._id === inspection.createdBy._id);

  //TODO isDepartment |= current user owns the report
  const sellerCostEstimate = getCostEstimateForType(state, 'seller', id);
  const departmentCostEstimate = isDepartmentOrOwnerOfInspection
    ? getCostEstimateForType(state, 'department', id)
    : null;
  return {
    backPath,
    role,
    id,
    sellerCostEstimate,
    departmentCostEstimate,
    isDepartment: isDepartmentOrOwnerOfInspection,
  };
};

export default withRouter(connect(mapStateToProps, Object.assign({}, actions))(withStyles(styles)(CostEstimateForm)));



// WEBPACK FOOTER //
// ./src/modules/costEstimate/components/readonly/CostEstimateForm.js